import { useState } from "react";

import { HomeMenuAdminPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuAdminPopout/HomeMenuAdminPopout";
import { HomeMenuContentLibraryPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuContentLibraryPopout/HomeMenuContentLibraryPopout";
import {
  fullWidthButtonCss,
  getHomeMenuPopoutContainerCss,
  supportItemVisibilityBreakpointCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuPopout/HomeMenuPopout.styles";
import { HomeMenuReportsPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuReportsPopout/HomeMenuReportsPopout";
import { HomeMenuSupportPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSupportPopout/HomeMenuSupportPopout";
import {
  ASSIGNMENTS_MENU_ITEM_STUDENT,
  ASSIGNMENTS_MENU_ITEM_TEACHER,
  HOME_MENU_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { useGetReportsMenuSectionProps } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useGetReportsMenuSectionProps/useGetReportsMenuSectionProps";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem/PopoutSectionItem";
import { PopoutSectionItemWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItemWithPopout/PopoutSectionItemWithPopout";
import useIsImraUser from "@/imra/useIsImraUser";
import { HomeMenuSubjectsPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/HomeMenu/HomeMenuSubjectsPopout/HomeMenuSubjectsPopout";
import useShowProductsSection from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useShowProductsSection";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { TrialButtons } from "../../PremiumTrial/TrialButtons/TrialButtons.component";

const HomeMenuPopout = () => {
  const { isStaff, isStudent, canViewAdminConsole, canViewSearch } =
    useGetUserProperties();

  const isImraUser = useIsImraUser();

  const { reportsMenuSectionTitle } = useGetReportsMenuSectionProps();

  const [isSubjectsOpen, setIsSubjectsOpen] = useState(false);
  const [isContentLibraryOpen, setIsContentLibraryOpen] = useState(false);
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isReportsOpen, setIsReportsOpen] = useState(false);
  const [isSupportOpen, setIsSupportOpen] = useState(false);

  const canSeeAdminMenu = isStaff || canViewAdminConsole;
  const hasOpenSubMenu =
    isContentLibraryOpen ||
    isReportsOpen ||
    isSupportOpen ||
    isAdminOpen ||
    isSubjectsOpen;

  const assignmentsHref = isStudent
    ? ASSIGNMENTS_MENU_ITEM_STUDENT.href
    : ASSIGNMENTS_MENU_ITEM_TEACHER.href;
  const contentLibrarySubMenuText = isStudent ? "Library" : "Content library";
  const showProductsSection = useShowProductsSection();

  return (
    <div css={getHomeMenuPopoutContainerCss(hasOpenSubMenu)}>
      <PopoutMenuSection width="12.5rem" title="">
        <TrialButtons rootCss={fullWidthButtonCss} />

        {showProductsSection && (
          <PopoutSectionItemWithPopout
            id="nav-menu-subjects-popout"
            buttonText="Subjects"
            isOpen={isSubjectsOpen}
            setIsOpen={setIsSubjectsOpen}
            position={{ right: "13rem", top: "0" }}
            PopoutComponent={
              <HomeMenuSubjectsPopout
                onClickBack={() => setIsSubjectsOpen(false)}
              />
            }
          />
        )}

        {canViewSearch && (
          <PopoutSectionItemWithPopout
            id="nav-menu-content-library-popout"
            buttonText={contentLibrarySubMenuText}
            isOpen={isContentLibraryOpen}
            setIsOpen={setIsContentLibraryOpen}
            position={{ right: "13rem", top: "0" }}
            PopoutComponent={
              <HomeMenuContentLibraryPopout
                onClickBack={() => setIsContentLibraryOpen(false)}
              />
            }
          />
        )}

        <PopoutSectionItemWithPopout
          id="nav-menu-classes-popout"
          buttonText={reportsMenuSectionTitle}
          isOpen={isReportsOpen}
          setIsOpen={setIsReportsOpen}
          position={{ right: "13rem", top: "0" }}
          PopoutComponent={
            <HomeMenuReportsPopout
              onClickBack={() => setIsReportsOpen(false)}
            />
          }
        />

        <PopoutSectionItem
          key={HOME_MENU_ITEMS.ASSIGNMENTS.title}
          href={assignmentsHref}
          title={HOME_MENU_ITEMS.ASSIGNMENTS.title}
          dataQASelector={HOME_MENU_ITEMS.ASSIGNMENTS.dataQASelector}
        />

        {!(isImraUser && isStudent) && (
          <PopoutSectionItemWithPopout
            id="nav-menu-support-popout"
            buttonText="Support"
            isOpen={isSupportOpen}
            setIsOpen={setIsSupportOpen}
            position={{ right: "13rem", top: "0" }}
            rootCustomCss={supportItemVisibilityBreakpointCss}
            PopoutComponent={
              <HomeMenuSupportPopout
                onClickBack={() => setIsSupportOpen(false)}
              />
            }
          />
        )}

        {canSeeAdminMenu && (
          <PopoutSectionItemWithPopout
            id="nav-menu-admin-popout"
            buttonText="Admin"
            isOpen={isAdminOpen}
            setIsOpen={setIsAdminOpen}
            position={{ right: "13rem", top: "0" }}
            PopoutComponent={
              <HomeMenuAdminPopout onClickBack={() => setIsAdminOpen(false)} />
            }
          />
        )}
      </PopoutMenuSection>
    </div>
  );
};

HomeMenuPopout.displayName = "HomeMenuPopout";
export { HomeMenuPopout };
